/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DisableModuleInput = {|
  moduleId: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type disableModuleMutationVariables = {|
  input: DisableModuleInput
|};
export type disableModuleMutationResponse = {|
  +disableModule: ?{|
    +deletedModuleId: string
  |}
|};
export type disableModuleMutation = {|
  variables: disableModuleMutationVariables,
  response: disableModuleMutationResponse,
|};
*/


/*
mutation disableModuleMutation(
  $input: DisableModuleInput!
) {
  disableModule(input: $input) {
    deletedModuleId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DisableModuleInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DisableModulePayload",
    "kind": "LinkedField",
    "name": "disableModule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedModuleId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "disableModuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "disableModuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "disableModuleMutation",
    "operationKind": "mutation",
    "text": "mutation disableModuleMutation(\n  $input: DisableModuleInput!\n) {\n  disableModule(input: $input) {\n    deletedModuleId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1ee77a361b98cd13bd205f4e306e16b7';

module.exports = node;
